import qs from "qs";
import { useState } from "react";
import { useLocation } from "react-router";
import { post } from "../../api";
import { CHANGE_NEWSLETTER_AGREEMENT, NEWSLETTER_AGREEMENT, RESIGN_FROM_NEWSLETTER } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";

export const NEWSLETTER_CONFIMRATION_SUCCESS = "NEWSLETTER_CONFIMRATION_SUCCESS";
export const NEWSLETTER_CONFIMRATION_WAITING = "NEWSLETTER_CONFIMRATION_WAITING";

const getFacilityIdsFromUrl = (search: string): string | undefined => {
  const query = qs.parse(search.startsWith("?") ? search.slice(1) : search);
  const rawValue = query.id ?? query.ids ?? query.facilityIds;
  const facilityId = Array.isArray(rawValue) ? rawValue[0] : rawValue;

  if (typeof facilityId !== "string" || facilityId.length === 0) {
    return undefined;
  }

  let normalized = facilityId.includes("/") ? facilityId.split("/")[0] : facilityId;
  if (normalized.startsWith("0,")) {
    normalized = normalized.substring(2);
  }

  return normalized;
};

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const [status, setStatus] = useState<string>(NEWSLETTER_CONFIMRATION_WAITING);
  const [alert, setAlert] = useState("");
  const location = useLocation();
  const facilityFromStore = useFacility();
  const facilityIds = getFacilityIdsFromUrl(location.search) || facilityFromStore;
  const hash = qs.parse(location.search.slice(1), {
    decoder: (str, decoder, charset, type) => {
      if (type === "value" || type === "key") {
        return decodeURIComponent(str);
      }
      return str;
    },
  }).hash as string;

  // console.log("hash", hash);

  const onConfirm = async () => {
    const { isError } = await post(CHANGE_NEWSLETTER_AGREEMENT(facilityIds, hash));
    if (!isError) {
      setStatus(NEWSLETTER_CONFIMRATION_SUCCESS);
    }
  };

  const sendInvite = async (ids: string, email: string) => {
    // post() z ../../api nie łapie własnych błędów (rzuca przy problemach sieciowych albo
    // nietypowej odpowiedzi serwera) — bez try/catch wyjątek stąd potrafił przerwać cały
    // checkout, skoro to wywołanie jest teraz await-owane przed saveReservation.
    try {
      const { isError } = await post(NEWSLETTER_AGREEMENT(ids, email));
      if (!isError) {
        setAlert("Dziękujemy. Za chwilę, na Twojej skrzynce pojawi się mail - wejdź i potwierdź zapis do newslettera.");
      }
    } catch (e) {
      // Cicho ignorujemy — zapis do newslettera jest best-effort, nie może wysadzić
      // wywołującego go flow (np. checkoutu).
    }
  };

  const resignNewsletter = async (ids: string, email: string) => {
    const { isError } = await post(RESIGN_FROM_NEWSLETTER(ids, email));
    if (!isError) {
      setAlert("Udało Ci się zrezygnować z newslettera.");
    }
  };

  return { alert, status, onConfirm, sendInvite, resignNewsletter };
};
